module.exports = __webpack_public_path__ + "static/media/zadania-matematyczne-klasa-6-m1.8cd32898.jpg";